// extracted by mini-css-extract-plugin
export default {"-large":"xtkhofg6ZKLc0HWsC7Sm","container":"wBoGY5xuIu_fBkbMRNts","replaceText":"fXoNEHzlLSGIgfH47Ad2","itemsContainer":"ioGwaI6MjoviWCvMoee2"};